import { render, staticRenderFns } from "./HorizontalRule.vue?vue&type=template&id=40b95692&"
import script from "./HorizontalRule.vue?vue&type=script&lang=js&"
export * from "./HorizontalRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports